///////////////////////////////////////////////////////
// Outline
///////////////////////////////////////////////////////
/*
    1. ΑΩ
        a. init
        b. destroy

    2. Interface
        a. datasource
        b. formatter
        c. select
        d. clear

    3. Helpers
        a. focusout
        b. focus
*/


(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3FacilityLookup', {
            templateUrl: 'app/shared/facility-lookup/facility-lookup.component.html',
            controller: FacilityLookupComponent,
            require: {
                ngModel: 'ngModel'
            },
            bindings: {
                name: '@',
                placeholder: '@',
                change: '&'
            }
        });

    var noop = angular.noop;

    FacilityLookupComponent.$inject = ['$scope', '$element', '$timeout', 'Facility', 'shared_resources', 'nationalAssociation', 'alert'];
    function FacilityLookupComponent($scope, $element, $timeout, Facility, resources, nationalAssociation, alert) {
        // Variables
        var ctrl = this, facility, current;

        // Properties
        ctrl.facility = null;
        ctrl.nationalAssociation = null;

        // Methods
        ctrl.$onInit = $timeout.bind(null, init);
        ctrl.datasource = datasource;
        ctrl.formatter = formatter;
        ctrl.select = select;
        ctrl.clear = clear;

        // Hijack focus method.  Has to be done outside of init.
        $element[0].focus = focus;

        ///////////////////////////////////////////////////////
        // ΑΩ
        ///////////////////////////////////////////////////////
        function init() {
            ctrl.facility = ctrl.ngModel.$modelValue;
            ctrl.nationalAssociation = facility && facility.nationalAssociation || nationalAssociation.RCGA;

            $element.on('focusout', focusout);
            $scope.$on('$destroy', destroy);
        }
        function destroy() {
            $element.off('focusout', focusout);
        }

        ///////////////////////////////////////////////////////
        // Interface
        ///////////////////////////////////////////////////////
        function datasource(text) {
            if (current)
                current.$cancelRequest();
            current = Facility.search({ nationalAssociation: ctrl.nationalAssociation, text: text, $top: 10 });

            return current.$promise.then(success, noop);

            function success(data) {
                return data.facilities;
            }
        }
        function formatter(facility) {
            return facility && facility.name || '';
        }
        function select(facility) {
            ctrl.ngModel.$setViewValue(facility);
            ctrl.change();
        }
        function clear() {
            select(ctrl.facility = null);
        }

        ///////////////////////////////////////////////////////
        // Helpers
        ///////////////////////////////////////////////////////
        function focusout(e) {
            var facility = ctrl.facility,
                facilityId = facility && facility.id || null;

            if (!$element[0].contains(document.activeElement)) {
                if (!facilityId)
                    $scope.$apply(clear);
                ctrl.ngModel.$$element.triggerHandler('blur');
            }
        }
        function focus() {
            $element.find('input')[0].focus();
        }
    }
})();